// ********************************Import********************************************

import Login from './components/Login';  // Pre-load login component

// login, forgot password and change password

//*********************************Exports links********************************************* */

// import { format } from "util";

// Helper function for lazy loading
const lazyLoad = (path) => {
  return () => import(/* webpackChunkName: "[request]" */ `./components/${path}`);
};

const lazyLoadPage = (path) => {
  return () => import(/* webpackChunkName: "[request]" */ `./pages/${path}`);
};

const routes = [
  // login, forgot password and change password

  {
    path: "/",
    name: "login",
    component: Login,  // Use pre-loaded login component
    meta: {
      title: "TMIS - United Nations Office on Drugs and Crime",
    },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: lazyLoad("forgotPassword"),
  },
  {
    path: "/resetPassword/:token",
    name: "resetPassword",
    component: lazyLoad("resetPassword"),
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: lazyLoad("changePassword"),
  },

  // Temporary
  {
    path: "/main-dashboard",
    name: "maindashboard",
    component: lazyLoad("MainDashboard"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  // Admin
  {
    path: "/dashboard/Admin/adminDashboardView",
    name: "adminDashboardView",
    component: lazyLoadPage("dashboard/Admin/adminDashboardView"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/adminStaticsReport",
    name: "adminStaticsReport",
    component: lazyLoadPage("dashboard/Admin/adminStaticsReport"),
    meta: {
      title: "Statistical Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingsReport",
    name: "trainingsReport",
    component: lazyLoadPage("dashboard/Admin/trainingsReport"),
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/thematicAreaReport",
    name: "thematicAreaReport",
    component: lazyLoadPage("dashboard/Admin/thematicAreaReport"),
    meta: {
      title: "Thematic Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/adminDashboard",
    name: "adminDashboard",
    component: lazyLoadPage("dashboard/Admin/adminDashboard"),
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailFundingAgencyTrainings",
    name: "detailFundingAgencyTrainings",
    component: lazyLoadPage("dashboard/Admin/detailFundingAgencyTrainings"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportSingleDetail",
    name: "trainingReportSingleDetail",
    component: lazyLoadPage("dashboard/Admin/trainingReportSingleDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/training/brief_training_report",
    name: "trainingBriefReportAdmin",
    component: lazyLoadPage("dashboard/Admin/trainingBriefReport"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/brief_training_report",
    name: "briefTrainingReportAdmin",
    component: lazyLoadPage("dashboard/Admin/brief_training_report"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/analysis-post-report",
    name: "analysisPostReportAdmin",
    component: lazyLoadPage("dashboard/Admin/analysis-post-report"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/individual_analysis_report",
    name: "analysisIndvidual",
    component: lazyLoadPage("dashboard/Admin/analysisIndvidual"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/detailProgramOfficer",
    name: "detailProgramOfficer",
    component: lazyLoadPage("dashboard/Admin/detailProgramOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/detailInfoTraining",
    name: "detailInfoTraining",
    component: lazyLoadPage("dashboard/Admin/detailInfoTraining"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailProgramOfficer",
    name: "detailProgramOfficer",
    component: lazyLoadPage("dashboard/Admin/detailProgramOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainer",
    name: "detailTrainer",
    component: lazyLoadPage("dashboard/Admin/detailTrainer"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainingCompleted",
    name: "detailTrainingCompleted",
    component: lazyLoadPage("dashboard/Admin/detailTrainingCompleted"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainee",
    name: "detailTrainee",
    component: lazyLoadPage("dashboard/Admin/detailTrainee"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailFundingAgency",
    name: "detailFundingAgency",
    component: lazyLoadPage("dashboard/Admin/detailFundingAgency"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailSubprogram",
    name: "detailSubprogram",
    component: lazyLoadPage("dashboard/Admin/detailSubprogram"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailProject",
    name: "detailProject",
    component: lazyLoadPage("dashboard/Admin/detailProject"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/employeeReg",
    name: "employeeReg",
    component: lazyLoadPage("dashboard/Admin/employeeReg"),
    meta: {
      title: "Employees",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/fundingAgency",
    name: "fundingAgency",
    component: lazyLoadPage("dashboard/Admin/fundingAgency"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/subProgram",
    name: "subProgram",
    component: lazyLoadPage("dashboard/Admin/subProgram"),
    meta: {
      title: "Subprogram",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/project",
    name: "project",
    component: lazyLoadPage("dashboard/Admin/project"),
    meta: {
      title: "Project",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/training",
    name: "training",
    component: lazyLoadPage("dashboard/Admin/training"),
    meta: {
      title: "Training",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/country",
    name: "country",
    component: lazyLoadPage("dashboard/Admin/country"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/province",
    name: "province",
    component: lazyLoadPage("dashboard/Admin/province"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/city",
    name: "city",
    component: lazyLoadPage("dashboard/Admin/city"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/designation",
    name: "designation",
    component: lazyLoadPage("dashboard/Admin/designation"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/role",
    name: "role",
    component: lazyLoadPage("dashboard/Admin/role"),
    meta: {
      title: "Role",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/relation-designation",
    name: "relation",
    component: lazyLoadPage("dashboard/Admin/relation-designation"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/profession",
    name: "profession",
    component: lazyLoadPage("dashboard/Admin/profession"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/department",
    name: "department",
    component: lazyLoadPage("dashboard/Admin/department"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/userDepartment",
    name: "userDepartment",
    component: lazyLoadPage("dashboard/Admin/userDepartment"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingCreate",
    name: "trainingCreate",
    component: lazyLoadPage("dashboard/Admin/trainingCreate"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/adminComingSoon",
    name: "adminComingSoon",
    component: lazyLoadPage("dashboard/Admin/adminComingSoon"),
  },
  {
    path: "/dashboard/Admin/KnowledgeBaseArchives",
    name: "KnowledgeBaseArchives",
    component: lazyLoadPage("dashboard/Admin/KnowledgeBaseArchives"),
    meta: {
      title: "Knowledge Base",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/KnowledgeBaseArchivesDetail",
    name: "KnowledgeBaseArchivesDetail",
    component: lazyLoadPage("dashboard/Admin/KnowledgeBaseArchivesDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/questionbankarchives",
    name: "questionbankarchives",
    component: lazyLoadPage("dashboard/Admin/QuestionBankArchives"),

    meta: {
      title: "Question Archives",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessment",
    name: "traineePreassessment",
    component: lazyLoadPage("dashboard/programOfficer/traineePreassessment"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/admin/trainingWizard",
    name: "traineePreassessment",
    component: lazyLoadPage("dashboard/Admin/trainingWizard"),
    meta: {
      title: "Event Wizard",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/eventEnclosure",
    name: "eventEnclosure",
    component: lazyLoadPage("dashboard/Admin/eventEnclosure"),
    meta: {
      title: "Event Enclosure",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/training_wizard",
    name: "adminTrainingWizardView",
    component: lazyLoadPage("dashboard/Admin/trainingWizardView"),
    meta: {
      title: "Event Wizard",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/essentialSystem",
    name: "essentialSystem",
    component: lazyLoadPage("dashboard/Admin/essentialSystem"),
    meta: {
      title: "Essential Data",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/programOfficer/brief_training_report",
    name: "brief_training_report",
    component: lazyLoadPage("dashboard/programOfficer/brief_training_report"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/individual_analysis_report",
    name: "individual_analysis_report",
    component: lazyLoadPage(
      "dashboard/programOfficer/individual_analysis_report"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/printReport",
    name: "printReport",
    component: lazyLoadPage("dashboard/programOfficer/printReport"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/addCertificate",
    name: "addCertificate",
    component: lazyLoadPage("dashboard/programOfficer/addCertificate"),
    meta: {
      title: "Certificate",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/advisor/training-Assignment",
    name: "trainingAssignment",
    component: lazyLoadPage("dashboard/Advisor/trainingAssignment"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/training-Information",
    name: "trainingInformation",
    component: lazyLoadPage("dashboard/programOfficer/trainingInformation"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/trainer-registration",
    name: "wizardTrainerRegistration",
    component: lazyLoadPage("dashboard/programOfficer/wizardTrainerRegistration"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/trainee-registration",
    name: "wizardTraineeRegistration",
    component: lazyLoadPage("dashboard/programOfficer/wizardTraineeRegistration"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/wizard-completion",
    name: "wizardCompletion",
    component: lazyLoadPage("dashboard/programOfficer/wizardCompletion"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/assesment-review",
    name: "wizardAssesmentReview",
    component: lazyLoadPage("dashboard/programOfficer/wizardAssesmentReview"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/training-agenda",
    name: "trainingAgendaWizard",
    component: lazyLoadPage("dashboard/programOfficer/trainingAgendaWizard"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/analysis-report",
    name: "analysisReport",
    component: lazyLoadPage("dashboard/programOfficer/analysisReport"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/admin/analysis-report",
    name: "analysisReportAdmin",
    component: lazyLoadPage("dashboard/Admin/analysisReportAdmin"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/advisor/analysis-report",
    name: "analysisReportAdvisor",
    component: lazyLoadPage("dashboard/Advisor/analysis-report"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/advisorDashboardView",
    name: "advisorDashboardView",
    component: lazyLoadPage("dashboard/Advisor/advisorDashboardView"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/TrainingsReportAdvisor",
    name: "TrainingsReportAdvisor",
    component: lazyLoadPage("dashboard/Advisor/TrainingsReportAdvisor"),
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/analysis-post-report",
    name: "analysisPostReport",
    component: lazyLoadPage("dashboard/programOfficer/analysis-post-report"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/advisor/analysis-post-report",
    name: "analysisAdvisorPostReport",
    component: lazyLoadPage("dashboard/Advisor/analysis-post-report"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePostassessment",
    name: "traineePostassessment",
    component: lazyLoadPage("dashboard/programOfficer/traineePostassessment"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessmentList",
    name: "traineePreassessmentList",
    component: lazyLoadPage(
      "dashboard/programOfficer/traineePreassessmentList"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessmentReport",
    name: "traineePreassessmentReport",
    component: lazyLoadPage(
      "dashboard/programOfficer/traineePreassessmentReport"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePostassessmentList",
    name: "traineePostassessmentList",
    component: lazyLoadPage(
      "dashboard/programOfficer/traineePostassessmentList"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/traineePostassessmentReport",
    name: "traineePostassessmentReport",
    component: lazyLoadPage(
      "dashboard/programOfficer/traineePostassessmentReport"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/Admin/questionBankAdmin",
    name: "QuestionBankAdmin",
    component: lazyLoadPage("dashboard/Admin/QuestionBankAdmin"),
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingType",
    name: "trainingType",
    component: lazyLoadPage("dashboard/Admin/trainingType"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addThematicArea",
    name: "addThematicArea",
    component: lazyLoadPage("dashboard/Admin/addThematicArea"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addTrainer",
    name: "addTrainer",
    component: lazyLoadPage("dashboard/Admin/addTrainer"),
    meta: {
      title: "Facilitators",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addTrainee",
    name: "addTrainee",
    component: lazyLoadPage("dashboard/Admin/addTrainee"),
    meta: {
      title: "Participant",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/subprogramList",
    name: "subprogramList",
    component: lazyLoadPage("dashboard/Admin/subprogramList"),
    meta: {
      title: "Subprogram",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/projectList",
    name: "projectList",
    component: lazyLoadPage("dashboard/Admin/projectList"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/Reports",
    name: "Reports",
    component: lazyLoadPage("dashboard/Admin/Reports"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportList",
    name: "trainingReportList",
    component: lazyLoadPage("dashboard/Admin/trainingReportList"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportSingle",
    name: "trainingReportSingle",
    component: lazyLoadPage("dashboard/Admin/trainingReportSingle"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/thematicArea",
    name: "thematicArea",
    component: lazyLoadPage("dashboard/Admin/thematicArea"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/ReportsFilter",
    name: "ReportsFilter",
    component: lazyLoadPage("dashboard/Admin/ReportsFilter"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/academicInfo",
    name: "academicInfo",
    component: lazyLoadPage("dashboard/Admin/academicInfo"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/graphs",
    name: "Graphs",
    component: lazyLoadPage("dashboard/Admin/graphs"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReport",
    name: "trainingReport",
    component: lazyLoadPage("dashboard/Admin/trainingReport"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/assignedTrainingsToAdvisor",
    name: "assignedTrainingsToAdvisor",
    component: lazyLoadPage("dashboard/Admin/assignedTrainingsToAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/programOfficerAssignedTrainings",
    name: "programOfficerAssignedTrainings",
    component: lazyLoadPage("dashboard/Admin/programOfficerAssignedTrainings"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/ReportAdminGraphs",
    name: "ReportAdminGraphs",
    component: lazyLoadPage("dashboard/Admin/ReportAdminGraphs"),
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/reportsAdminAll",
    name: "reportsAdminAll",
    component: lazyLoadPage("dashboard/Admin/reportsAdminAll"),
    meta: {
      title: "Brief Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/strategicReport",
    name: "strategicReport",
    component: lazyLoadPage("dashboard/Admin/strategicReport"),
    meta: {
      title: "Startegic Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/map",
    name: "map",
    component: lazyLoadPage("dashboard/Admin/map"),
    meta: {
      title: "Map",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  // Advisor
  {
    path: "/dashboard/Advisor",
    name: "advisor_form",
    component: lazyLoadPage("dashboard/Advisor/advisor_form"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/Advisor/QuestionBank",
    name: "QuestionBank",
    component: lazyLoadPage("dashboard/Advisor/QuestionBank"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/individual_analysis_report",
    name: "indvidualAdvisorReport",
    component: lazyLoadPage("dashboard/Advisor/individual_analysis_report"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/advisor/brief_training_report",
    name: "briefTrainingReport",
    component: lazyLoadPage("dashboard/Advisor/brief_training_report"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/Advisor/trainingReportSingleDetail",
    name: "AdvisortrainingReportSingleDetail",
    component: lazyLoadPage("dashboard/Advisor/trainingReportSingleDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/advisorComingSoon",
    name: "advisorComingSoon",
    component: lazyLoadPage("dashboard/Advisor/advisorComingSoon"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/questionbankarchives",
    name: "AdvisorQuestionBankArchives",
    component: lazyLoadPage("dashboard/Advisor/QuestionBankArchives"),
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/KnowledgeBaseArchives",
    name: "AdvisorKnowledgeBaseArchives",
    component: lazyLoadPage("dashboard/Advisor/KnowledgeBaseArchives"),
    meta: {
      title: "Knowledge Archives",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/KnowledgeBaseArchivesDetail",
    name: "AdvisorKnowledgeBaseArchivesDetail",
    component: lazyLoadPage("dashboard/Advisor/KnowledgeBaseArchivesDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/advisordashboard",
    name: "AdvisorDashboard",
    component: lazyLoadPage("dashboard/Advisor/AdvisorDashboard"),
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/conductedTraining",
    name: "ConductedTraining",
    component: lazyLoadPage("dashboard/Advisor/conductedTraining"),
    meta: {
      title: "Assigned Trainings",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/inprocesstrainings",
    name: "InprocessTrainings",
    component: lazyLoadPage("dashboard/Advisor/inprocesstrainings"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/approvedtrainings",
    name: "ApprovedTrainings",
    component: lazyLoadPage("dashboard/Advisor/approvedtrainings"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingDetailView",
    name: "trainingDetailView",
    component: lazyLoadPage("dashboard/Advisor/trainingDetailView"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsAdvisorGraphs",
    name: "ReportsAdvisorGraphs",
    component: lazyLoadPage("dashboard/Advisor/ReportsAdvisorGraphs"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsFilterAdvisor",
    name: "ReportsFilterAdvisor",
    component: lazyLoadPage("dashboard/Advisor/ReportsFilterAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsAdvisor",
    name: "ReportsAdvisor",
    component: lazyLoadPage("dashboard/Advisor/ReportsAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/GraphsAdvisor",
    name: "GraphsAdvisor",
    component: lazyLoadPage("dashboard/Advisor/GraphsAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingReportAdvisor",
    name: "trainingReportAdvisor",
    component: lazyLoadPage("dashboard/Advisor/trainingReportAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/thematicAreaAdvisor",
    name: "thematicAreaAdvisor",
    component: lazyLoadPage("dashboard/Advisor/thematicAreaAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingReportListAdvisor",
    name: "trainingReportListAdvisor",
    component: lazyLoadPage("dashboard/Advisor/trainingReportListAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  // {
  //     path: "/dashboard/Admin/trainingReportSingle",
  //     name: "trainingReportSingle",
  //     component: trainingReportSingle
  // },
  {
    path: "/dashboard/Advisor/subprogramListAdvisor",
    name: "subprogramListAdvisor",
    component: lazyLoadPage("dashboard/Advisor/subprogramListAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/projectListAdvisor",
    name: "projectListAdvisor",
    component: lazyLoadPage("dashboard/Advisor/projectListAdvisor"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/reportsAdvisorAll",
    name: "reportsAdvisorAll",
    component: lazyLoadPage("dashboard/Advisor/reportsAdvisorAll"),
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  // Program Officer
  {
    path: "/dashboard/program-officer/todoList",
    name: "programOfficer",
    component: lazyLoadPage("dashboard/programOfficer/todoList"),
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/conductedTraining",
    name: "ConductedTrainingOfficer",
    component: lazyLoadPage("dashboard/programOfficer/conductedTraining"),
    meta: {
      title: "Assigned Trainings",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/form",
    name: "form",
    component: lazyLoadPage("dashboard/programOfficer/form"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/registration",
    name: "Registration",
    component: lazyLoadPage("dashboard/programOfficer/registration"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/quickTrainerReg",
    name: "Registration",
    component: lazyLoadPage("dashboard/programOfficer/quickTrainerReg"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/trainees-approval",
    name: "traineesApproval",
    component: lazyLoadPage("dashboard/programOfficer/trainees-approval"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/trainee-material-approval",
    name: "traineeMaterialsApproval",
    component: lazyLoadPage(
      "dashboard/programOfficer/trainee-material-approval"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/detail-registration",
    name: "DetailRegistration",
    component: lazyLoadPage("dashboard/programOfficer/detail-registration"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/knowledgeBase",
    name: "knowledge-base",
    component: lazyLoadPage("dashboard/programOfficer/knowledgeBase"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/QuestionBank",
    name: "QuestionBank",
    component: lazyLoadPage("dashboard/programOfficer/QuestionBank"),
    meta: {
      title: "Create Question",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/AgendaForm",
    name: "AgendaForm",
    component: lazyLoadPage("dashboard/programOfficer/AgendaForm"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/program-officer/officerComingSoon",
    name: "officerComingSoon",
    component: lazyLoadPage("dashboard/programOfficer/officerComingSoon"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/assessment",
    name: "programOfficerAssessment",
    component: lazyLoadPage("dashboard/programOfficer/assessment"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/postassessment",
    name: "programOfficerPostAssessment",
    component: lazyLoadPage("dashboard/programOfficer/postassessment"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/createtrainerFeedback",
    name: "createtrainerFeedback",
    component: lazyLoadPage("dashboard/programOfficer/createtrainerFeedback"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/createTraineesFeedback",
    name: "createTraineesFeedback",
    component: lazyLoadPage("dashboard/programOfficer/createTraineesFeedback"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/questionbankarchives",
    name: "programOfficerQuestionBankArchives",
    component: lazyLoadPage("dashboard/programOfficer/QuestionBankArchives"),
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/KnowledgeBaseArchive",
    name: "KnowledgeBaseArchive",
    component: lazyLoadPage("dashboard/programOfficer/KnowledgeBaseArchive"),
    meta: {
      title: "Knowledge Base",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/KnowledgeBaseArchiveDetail",
    name: "KnowledgeBaseArchiveDetail",
    component: lazyLoadPage(
      "dashboard/programOfficer/KnowledgeBaseArchiveDetail"
    ),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/addTrainee",
    name: "AddTraineePO",
    component: lazyLoadPage("dashboard/programOfficer/AddTraineePO"),
    meta: {
      title: "Participant",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/previewQuestions",
    name: "previewQuestions",
    component: lazyLoadPage("dashboard/programOfficer/previewQuestions"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/ReportsFilterOfficer",
    name: "ReportsFilterOfficer",
    component: lazyLoadPage("dashboard/programOfficer/ReportsFilterOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/officerDashboardView",
    name: "officerDashboardView",
    component: lazyLoadPage("dashboard/programOfficer/officerDashboardView"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/TrainingsReportOfficer",
    name: "TrainingsReportOfficer",
    component: lazyLoadPage("dashboard/programOfficer/TrainingsReportOfficer"),
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/ReportsOfficer",
    name: "ReportsOfficer",
    component: lazyLoadPage("dashboard/programOfficer/ReportsOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/GraphsOfficer",
    name: "GraphsOfficer",
    component: lazyLoadPage("dashboard/programOfficer/GraphsOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/trainingReportOfficer",
    name: "trainingReportOfficer",
    component: lazyLoadPage("dashboard/programOfficer/trainingReportOfficer"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/ReportsOfficerGraphs",
    name: "ReportsOfficerGraphs",
    component: lazyLoadPage("dashboard/programOfficer/ReportsOfficerGraphs"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/attendanceSheet",
    name: "attendanceSheet",
    component: lazyLoadPage("dashboard/programOfficer/attendanceSheet"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/feedbackTrainer",
    name: "feedbackTrainer",
    component: lazyLoadPage("dashboard/programOfficer/feedbackTrainer"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/feedbackTrainee",
    name: "feedbackTrainee",
    component: lazyLoadPage("dashboard/programOfficer/feedbackTrainee"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/regFormTrainee",
    name: "regFormTrainee",
    component: lazyLoadPage("dashboard/programOfficer/regFormTrainee"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/registerationReport",
    name: "registerationReport",
    component: lazyLoadPage("dashboard/programOfficer/registerationReport"),
  },
  {
    path: "/dashboard/programOfficer/agendaFormReport",
    name: "agendaFormReport",
    component: lazyLoadPage("dashboard/programOfficer/agendaFormReport"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/training-assesment",
    name: "wizardTrainingAssesment",
    component: lazyLoadPage("dashboard/programOfficer/wizardTrainingAssesment"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/wizardUploadMaterial",
    name: "wizardUploadMaterial",
    component: lazyLoadPage("dashboard/programOfficer/wizardUploadMaterial"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/reportsOfficerAll",
    name: "reportsOfficerAll",
    component: lazyLoadPage("dashboard/programOfficer/reportsOfficerAll"),
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  // Trainer
  {
    path: "/dashboard/Trainer/Trainer_Registration_Form",
    name: "trainer-registration",
    component: lazyLoadPage("dashboard/Trainer/Trainer_Registration_Form"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerDashboard",
    name: "TraineeReg",
    component: lazyLoadPage("dashboard/Trainer/trainerDashboard"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/brief_training_report",
    name: "BriefTrainingReportT",
    component: lazyLoadPage("dashboard/Trainer/brief_training_report"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/analysisReport",
    name: "BriefTrainingAnalysisReportT",
    component: lazyLoadPage("dashboard/Trainer/analysisReport"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/individual_analysis_report",
    name: "BriefTrainingIndvidualReportT",
    component: lazyLoadPage("dashboard/Trainer/individual_analysis_report"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },

  {
    path: "/dashboard/Trainer/comingSoon",
    name: "TraineeReg",
    component: lazyLoadPage("dashboard/Trainer/comingSoon"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/inbox",
    name: "TrainerInbox",
    component: lazyLoadPage("dashboard/Trainer/inbox"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerFeedback",
    name: "trainerFeedback",
    component: lazyLoadPage("dashboard/Trainer/trainerFeedback"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/quickTraineeReg",
    name: "quickTraineeReg",
    component: lazyLoadPage("dashboard/Trainer/quickTraineeReg"),
  },
  {
    path: "/dashboard/Trainer/QuestionBank",
    name: "QuestionBank",
    component: lazyLoadPage("dashboard/Trainer/QuestionBank"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/TrainerknowledgeBase",
    name: "TrainerknowledgeBase",
    component: lazyLoadPage("dashboard/Trainer/TrainerknowledgeBase"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/knowledgeBaseRepDetail",
    name: "knowledgeBaseRepDetail",
    component: lazyLoadPage("dashboard/Trainer/knowledgeBaseRepDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainingProgInfo",
    name: "trainingProg",
    component: lazyLoadPage("dashboard/Trainer/trainingProgInfo"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/uploadTrainingMaterial",
    name: "uploadMaterial",
    component: lazyLoadPage("dashboard/Trainer/uploadTrainingMaterial"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/Gallery",
    name: "videosTrainer",
    component: lazyLoadPage("dashboard/Trainer/Gallery"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerPrevTraining",
    name: "trainerPrevTraining",
    component: lazyLoadPage("dashboard/Trainer/trainerPrevTraining"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/traineePrevTraining",
    name: "traineePrevTraining",
    component: lazyLoadPage("dashboard/Trainer/traineePrevTraining"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/trainer/reportsTrainerAll",
    name: "reportsTrainerAll",
    component: lazyLoadPage("dashboard/Trainer/reportsTrainerAll"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainingAgenda",
    name: "trainingAgenda",
    component: lazyLoadPage("dashboard/Trainer/trainingAgenda"),
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },

  // Trainee

  {
    path: "/dashboard/Trainee/traineeDashboard",
    name: "traineeDashboard",
    component: lazyLoadPage("dashboard/Trainee/traineeDashboard"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/change-password",
    name: "changePasswordTrainee",
    component: lazyLoadPage("dashboard/Trainee/change-password"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  // this will show single training of a trainee
  {
    path: "/dashboard/Trainee/single-training-show",
    name: "singleTrainingShow",
    component: lazyLoadPage("dashboard/Trainee/single-training-show"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBase",
    name: "knowledge-base",
    component: lazyLoadPage("dashboard/Trainee/knowledgeBase"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/addReference",
    name: "addReference",
    component: lazyLoadPage("dashboard/Trainee/addReference"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/TraineeReg",
    name: "TraineeReg",
    component: lazyLoadPage("dashboard/Trainee/TraineeReg"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/comingSoon",
    name: "TraineeReg",
    component: lazyLoadPage("dashboard/Trainee/comingSoon"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/preassessment",
    name: "PreAssessment",
    component: lazyLoadPage("dashboard/Trainee/PreAssessment"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/postassessment",
    name: "PostAssessment",
    component: lazyLoadPage("dashboard/Trainee/PostAssessment"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/inbox",
    name: "Inbox",
    component: lazyLoadPage("dashboard/Trainee/inbox"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/feedback",
    name: "Feedback",
    component: lazyLoadPage("dashboard/Trainee/Feedback"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBaseRepository",
    name: "knowledgeBaseRepository",
    component: lazyLoadPage("dashboard/Trainee/knowledgeBaseRepository"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/trainee-questions",
    name: "traineeQuestions",
    component: lazyLoadPage("dashboard/Trainee/trainee-questions"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBaseRepDetail",
    name: "knowledgeBaseRepDetail",
    component: lazyLoadPage("dashboard/Trainee/knowledgeBaseRepDetail"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/videos",
    name: "videos",
    component: lazyLoadPage("dashboard/Trainee/videos"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/gallery",
    name: "Gallery",
    component: lazyLoadPage("dashboard/Trainee/gallery"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/certificates",
    name: "Certificates",
    component: lazyLoadPage("dashboard/Trainee/certificates"),
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
];

export default routes;
